import React, { useEffect, useState } from 'react';
import { testFirebaseConnection } from '../test_firebase_connection';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const FirebaseConnectionTest = () => {
  const [connectionStatus, setConnectionStatus] = useState('Testing...');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkConnection = async () => {
      try {
        setIsLoading(true);
        const success = await testFirebaseConnection();
        setConnectionStatus(success ? 'Connected' : 'Failed to connect');
      } catch (err) {
        setError(err.message);
        setConnectionStatus('Error');
      } finally {
        setIsLoading(false);
      }
    };

    checkConnection();
  }, []);

  return (
    <Card className="w-full max-w-md mx-auto mt-8">
      <CardHeader>
        <CardTitle>Firebase Connection Test</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <span className="font-medium">Connection Status:</span>
            <span 
              className={`px-3 py-1 rounded-full text-sm font-medium ${
                isLoading 
                  ? 'bg-yellow-100 text-yellow-800' 
                  : connectionStatus === 'Connected' 
                    ? 'bg-green-100 text-green-800' 
                    : 'bg-red-100 text-red-800'
              }`}
            >
              {isLoading ? 'Testing...' : connectionStatus}
            </span>
          </div>
          
          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-md text-red-700 text-sm">
              <p className="font-medium">Error:</p>
              <p>{error}</p>
            </div>
          )}
          
          <div className="text-sm text-gray-500">
            <p>This component tests the connection to Firebase Firestore.</p>
            <p>Check the console for detailed logs.</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default FirebaseConnectionTest;